import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';

const DOMAIN_SEGMENTS_COUNT = 2;
const OWNED_HOSTNAME_DOMAINS = [SourceDomain.PflegiaDe, SourceDomain.PraxiaDe];

const checkIfIsValidHostname = (hostname: string) =>
  OWNED_HOSTNAME_DOMAINS.some(domain => new RegExp(`(^|\\.)${domain.replace('.', '\\.')}$`, 'i').test(hostname));
const checkIfIsApexDomain = (hostname: string) => OWNED_HOSTNAME_DOMAINS.some(domain => hostname.toLowerCase() === domain);

const sanitizeUrl = (hostname: string) => hostname.replace(/^(https?:\/\/)/, '').replace(/\/+$/g, '');

/**
 * Return the correct domain by hostname
 * @param hostname
 * @returns
 */
export const getDomainWithPrefixByHostName = (hostname?: string) => {
  if (!hostname || !checkIfIsValidHostname(hostname)) return `www.${SourceDomain.PflegiaDe}`;

  return checkIfIsApexDomain(hostname) ? `www.${hostname}` : hostname;
};

export const replaceDomainByCurrentSourceDomain = (currentUrl?: string, sourceDomain?: SourceDomain): string => {
  if (!currentUrl) return `www.${sourceDomain ?? SourceDomain.PflegiaDe}`;
  if (!sourceDomain) return currentUrl;

  const match = Object.values(SourceDomain).find(domain => currentUrl.endsWith(domain));
  if (match) return currentUrl.replace(new RegExp(`${match}$`), String(sourceDomain));
  const subdomains = currentUrl.split('.').slice(0, -DOMAIN_SEGMENTS_COUNT).join('.');
  return subdomains ? `${subdomains}.${sourceDomain}` : `www.${sourceDomain}`;
};

export const getBaseUrlByHostName = (domain?: string) => `https://${getDomainWithPrefixByHostName(domain)}`;
export const getBaseUrlByCurrentSourceDomain = (currentUrl = '', sourceDomain?: SourceDomain) =>
  `https://${replaceDomainByCurrentSourceDomain(sanitizeUrl(currentUrl), sourceDomain)}`;
